/* eslint-disable arrow-body-style */
import React, { useMemo, useState } from 'react';
import { Justify, Segment } from "tea-component";
import { getLocale, useSelector } from 'umi';
import { getExplainVal } from '../../utils/getExplainVal';

import './index.scss';

export default function MetricsSegementCo(props: any) {
  const { style, className, type, config, children, ...resetProps } = props || {};
  const { metricsInit, componentMetrics = [] } = config || {};
  const isEN = getLocale() === 'en-US';
  const [selectedValue, setSelectedValue] = useState(metricsInit || '');
  const  explainInfo  = useSelector((state: any) => {
    return state.dashboard?.explainInfo;
  });
  const options = useMemo(() => {
    return componentMetrics?.map((item: any) => {
      const { enName, cnName, metricKey, rainbowKey, explainEn = '', explainCn = '' } = item;
      const explain = getExplainVal(explainInfo, rainbowKey, getLocale(), explainEn, explainCn);
      return {
        text: isEN ? enName : cnName,
        value: metricKey,
        bubble: explain?.replaceAll('\\n', '<br/>'),
      };
    });
  }, [componentMetrics, isEN]);

  const selectedMetric = useMemo(() => {
    const metric = componentMetrics?.find((item: any) => item?.metricKey === selectedValue) || [];
    return metric;
  }, [componentMetrics, selectedValue]);

  return (
    <div className={className} style={style}>
      <Justify
        className='register-justify-mb'
        left={
          <Segment
            className={isEN ? "segment-light" : "segment-light segment-light-china"}
            value={selectedValue}
            onChange={(val) => {
              setSelectedValue(val);
            }}
            options={options}
          />
        }
      />
      {
        React.Children.map(children, (child: any) => {
          return React.cloneElement(
            child,
            {
              ...resetProps,
              selectedValue,
              selectedMetric,
              state: {}
            }
          );
        })
      }
    </div>
  );
}
